// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qo_a bhs_sw bhs_kx bhs_ky","PostDetailRight__brandDaysPosts":"qo_b bhs_sw bhs_kx bhs_ky"};